import { VibeCheckOptionsType } from './types';

export const VIBE_CHECK_OPTIONS: VibeCheckOptionsType = [
  {
    id: 'electric_chemistry',
    title: 'Electric chemistry',
  },
  {
    id: 'tender_soft',
    title: 'Tender & soft',
  },
  {
    id: 'drunk_wild',
    title: 'Drunk & wild',
  },
  {
    id: 'awkward_cute',
    title: 'Awkward but cute',
  },
  {
    id: 'dangerous_seductive',
    title: 'Dangerous & seductive',
  },
];
